/**
 * GoTrue rejects a password it considers weak with code `weak_password` plus the
 * reasons. "pwned" comes from leaked-password protection (HaveIBeenPwned): the
 * exact password sits in a public breach list. The account holder did nothing
 * wrong except reuse it, so say that plainly instead of echoing GoTrue's
 * English "known to be weak and easy to guess".
 */
export const PWNED_PASSWORD_MESSAGE =
  "Kata laluan ini pernah terdedah dalam kebocoran data di internet. Sila pilih kata laluan lain yang belum pernah anda guna di tempat lain.";

export const WEAK_PASSWORD_MESSAGE =
  "Kata laluan terlalu lemah. Sila pilih kata laluan yang lebih panjang dan sukar diteka.";

interface AuthErrorLike {
  message?: string;
  code?: string;
  reasons?: unknown;
}

export function isWeakPasswordError(err: unknown): boolean {
  return (err as AuthErrorLike | null)?.code === "weak_password";
}

export function authErrorMessage(err: unknown, fallback: string): string {
  const e = err as AuthErrorLike | null | undefined;
  if (e?.code === "weak_password") {
    const reasons = Array.isArray(e.reasons) ? e.reasons : [];
    return reasons.includes("pwned") ? PWNED_PASSWORD_MESSAGE : WEAK_PASSWORD_MESSAGE;
  }
  return e?.message || fallback;
}
